<template>
	<div class="">

		<template v-if="device!='pc'">
			<div class="full flex" style="flex-direction: column;">
				<div style="flex: 1;">
					<div class="graph" style="display: none;" id="reback_graph"></div>
					<van-radio-group v-model="radio" @change="radioChange">
						<van-cell-group>
							<van-cell v-for="(item,index) in useablenodes" :key="index" :label="item.name" :title="item.staffnames"
								clickable @click="radioClick(item.id)">
								<template #right-icon>
									<van-radio :name="item.id"
										:disabled="item.id == currentFlowprogress.currentnodeid || !item.enable" />
								</template>
							</van-cell>
						</van-cell-group>
					</van-radio-group>
				</div>
				<div class="flex">
					<van-button type="default" style="flex: 1;" text="返回" @click="$emit('back',{type:'cancle'})">
					</van-button>
					<van-button type="primary" style="flex: 1;" text="确认" @click="$emit('back',{type:'confirm'})">
					</van-button>
				</div>
				<van-popup v-model="commentShow" :style="{ height: '90%' ,width:'90%'}" title="必要信息">
					<div class="full flex" style="flex-direction: column;align-items: center;justify-content: center;">
						<div class="full" style="position: relative;flex: 1;box-sizing: border-box;padding: 0 4px;">
							<!-- <van-divider>提交方式</van-divider> -->
							<van-radio-group v-model="type">
								<van-cell-group>
									<van-cell clickable title="直接提交给我" @click="type = 1">
										<template #right-icon>
											<van-radio :name="1" />
										</template>
									</van-cell>
									<van-cell clickable title="按流程提交" @click="type = 2">
										<template #right-icon>
											<van-radio :name="2" />
										</template>
									</van-cell>
								</van-cell-group>
							</van-radio-group>
							<van-field v-model="comment" rows="10" autosize label="建议" type="textarea"
								placeholder="请输入建议" />
							<!-- 							<div style="position: relative;width: 100%;height: 200px;">
								<tinymce ref="comment"></tinymce>
							</div> -->
						</div>
						<div class="flex" style="width: 100%;">
							<van-button type="default" style="flex: 1;" text="返回" @click="commentShow=false">
							</van-button>
							<van-button type="primary" style="flex: 1;" text="确认"
								@click="commentSubmit({type:'confirm'})"></van-button>
						</div>
					</div>
				</van-popup>
			</div>
		</template>
		<template v-else>
			<div class="graph" id="reback_graph">
				<vxe-table border :data="useablenodes" @radio-change="tableRadioChange"
					:radio-config="{highlight: true,trigger: 'row',checkMethod:checkRadioMethod}">
					<vxe-column type="radio" title="#" width="50px"></vxe-column>
					<vxe-column field="tag" title="操作"></vxe-column>
					<!-- <vxe-column field="id" title="nodeID"></vxe-column> -->
					<!-- <vxe-column field="nodetype" title="nodetype"></vxe-column> -->
					<vxe-column field="staffnames" title="节点执行人"></vxe-column>
					<!-- <vxe-column field="groupid" title="groupid"></vxe-column> -->
					<!-- <vxe-column field="create_time" title="创建时间"></vxe-column> -->
					
					<vxe-column field="submit" title="执行方式">
						<template #default="{ row }">
							<span v-if="row.submit==1">发起</span>
							<span v-if="row.submit==2">提交</span>
							<span v-if="row.submit==3">退回</span>
							<span v-if="!row.submit">等待执行</span>
						</template>
					</vxe-column>
					<vxe-column field="name" title="节点名称"></vxe-column>
				</vxe-table>
			</div>


			<vxe-modal v-model="commentShow" width="600" height="500" :destroy-on-close="false" title="必要信息" show-footer
				:before-hide-method="commentSubmit">
				<template #default>
					<div style="margin-bottom: 20px;margin-top: 10px;">
						<div style="display: inline-block;margin-right: 20px;">提交方式：</div>
						<el-radio v-model="type" :label="1">直接提交给我</el-radio>
						<el-radio v-model="type" :label="2">按流程提交</el-radio>
					</div>
					<el-divider content-position="left">建议</el-divider>
					<div style="position: relative;width: 100%;height: 300px;">
						<tinymce ref="comment"></tinymce>
					</div>
				</template>
			</vxe-modal>


		</template>







	</div>

</template>
<style scoped>

</style>
<script>
	import tinymce from '@_system/components/tinymce.vue'
	export default {
		props: {
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			},
			flowprogress: {
				type: Object,
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				type: 1,
				currentFlowprogress: null,
				predecessorFlowprogress: null,
				commentShow: false,
				graph: null,
				selectNode: null,
				comment: null,
				radio: '',
				useablenodes: [],
				device: window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			this.$nextTick(() => {
				let data = []
				let res = this.flowprogress
				let current = res.current
				let predecessor = res.predecessor
				this.predecessorFlowprogress = predecessor
				let template = current.template
				if (!current.nextstaffid) {
					this.currentFlowprogress = current
					predecessor.forEach((item) => {	
						let cell = this.getCellByNodeid(item.currentnodeid, template.flowtemplate.cells)
						if (cell) {
							if(item.currentnodetype!=3){
								let obj = {
									progressid:item.id,
									id: cell.id,
									nodetype: cell.data.nodetype,
									name: cell.data.name ,
									staffids: [item.currentstaffid],
									staffnames: '',
									submit: item.submit,
									groupid: item.groupid,
									enable: true,
									tag: item.tag,
									create_time: item.create_time
								}
								data.push(obj)
							}
						}
					})
					data.forEach((item)=>{
						if(!item.submit){
							item.enable = false
						}
					})
					data = this.mergeArrayBygGroupidId(data)
					//console.log(data)
					data.forEach((item) => {
						item.staffnames = window.systemMethods.getstaff(item.staffids)
						item.create_time = window.systemMethods.timestampToDate(item.create_time)
					})
					this.useablenodes = data.filter((item)=>{
						return item.enable
					})
					
					this.filterSameNode()
				} else {
					this.error = true
					this.$confirm('下一节点处理人已确定，无法再次退回', '退回错误', {
						status: 'error',
					}).then(() => {
						this.$emit('error')
					})

				}



			})
		},
		watch: {

		},
		computed: {

		},
		methods: {
			checkRadioMethod({
				row
			}) {
				return row.id != this.currentFlowprogress.currentnodeid && row.enable
			},
			getstaffByNodeid(id, nodes) {
				let staffid = 0
				nodes.forEach((item) => {
					//console.log(id, item.currentnodeid)
					if (item.currentnodeid == id) {
						staffid = item.currentstaffid
					}
				})
				return window.systemMethods.getstaff(staffid)
			},
			getCellByNodeid(id, nodes) {
				let obj = nodes.find((item) => {
					return item.id === id
				})
				return obj
			},
			filterSameNode() {
				let data = []
				// let targetdata = this.useablenodes.reverse()
				let targetdata = this.useablenodes
				//console.log(targetdata,11)
				targetdata.forEach((item)=>{
					let exist = data.find((ex)=>{
						return ex.id == item.id && JSON.stringify(ex.staffids) == JSON.stringify(item.staffids)
					})
					if(!exist && item.submit!=3 && item.id != this.currentFlowprogress.currentnodeid){
						data.push(item)
					}
				})
				// this.useablenodes = data.reverse()
				this.useablenodes = data
				
			},
			mergeArrayBygGroupidId(arr) {
				//console.log(arr)
				let result = []
				arr.forEach(item => {
					let existingItem = result.find((resultItem) => {
						return resultItem.groupid === item.groupid
					})
					if (existingItem && item.submit === existingItem.submit) {
							existingItem.staffids = existingItem.staffids.concat(item.staffids)						
					} else {
						result.push(item)
					}
				})
				return result
			},
			commentSubmit(e) {
				if (e.type == 'confirm') {
					let value = this.device != 'pc' ? this.comment : this.$refs.comment.myValue
					if (value) {
						this.comment = value
						this.commentShow = false
					} else {
						this.$message.error('请填写建议')
						return new Error()
					}
				}


			},
			tableRadioChange({row}) {
				let node = this.useablenodes.find((item) => {
					return item.id == row.id
				})
				if (node) {
					this.selectNode = [node]
				}
			},
			radioChange(e) {
				let node = this.useablenodes.find((item) => {
					return item.id == e
				})
				if (node) {
					this.selectNode = [node]
				}
			},
			radioClick(e) {
				//console.log(e)
				if (e != this.currentFlowprogress.currentnodeid) {
					this.radio = e
				}

			},
			submit() {
				if (!this.selectNode) {
					this.$message.error('请选择节点')
					return false
				} else if (this.currentFlowprogress.currentnodeid == this.selectNode[0].id) {
					this.$message.error('不能选择自己')
					return false
				} else if (!this.comment) {
					this.commentShow = true
					return false
				} else {
					let rebackflowprogressid = null
					this.predecessorFlowprogress.forEach((item) => {
						if (item.id == this.selectNode[0].progressid) {
							rebackflowprogressid = item.id
						}
					})
					return {
						comment: this.comment,
						fromstaffid: this.$store.state.system.user.id,
						fromstaffname: this.$store.state.system.user.name,
						type: this.type,
						rebackflowprogressid: rebackflowprogressid
					}
				}

			},

		},
		components: {
			tinymce
		}
	}
</script>
